module.exports = __webpack_public_path__ + "img/left-cloud.4a8f5e84.png";